import { defineStore } from "pinia";
import { ref } from "vue";
import { client } from "@/main";
export const useCommonDevicesStore = defineStore("commonDevices", () => {
    const deviceCommonList = ref([]);
    const deviceCommonListCount = ref(0);
    async function getDeviceCommonList(queryObj) {
        const sortPrefix = queryObj.sortType === "asc" ? "+" : "-";
        const baseParams = {
            "projectId[eq]": queryObj.filters.projectId,
            "deviceGroupId[eq]": queryObj.filters.deviceGroupId,
            search: queryObj.search || undefined,
            limit: queryObj.rowsPerPage,
            offset: queryObj.currentPage * queryObj.rowsPerPage
        };
        const [loraData, mqttData, udpData] = await Promise.all([
            client.path("/lora/devices").method("get").create()({ ...baseParams, sort: sortPrefix + queryObj.sort }),
            client.path("/mqtt/devices").method("get").create()({ ...baseParams, sort: sortPrefix + queryObj.sort }),
            client.path("/udp/devices").method("get").create()({
                ...baseParams,
                sort: sortPrefix + (queryObj.sort === "custDeviceName" ? "name" : queryObj.sort)
            })
        ]);
        const allDevices = [
            ...(loraData.data.data ?? []).map((d) => ({ ...d, deviceProtocol: "lora" })),
            ...(mqttData.data.data ?? []).map((d) => ({ ...d, deviceProtocol: "mqtt" })),
            ...(udpData.data.data ?? []).map((d) => ({ ...d, deviceProtocol: "udp" }))
        ];
        const count = (loraData.data.metadata?.count ?? 0) + (mqttData.data.metadata?.count ?? 0) + (udpData.data.metadata?.count ?? 0);
        deviceCommonList.value = allDevices;
        deviceCommonListCount.value = count;
        return allDevices;
    }
    async function getDevicesByFilter(filter) {
        const { data } = await client.path("/devices").method("get").create()({
            ...filter
        });
        return data;
    }
    return {
        deviceCommonList,
        deviceCommonListCount,
        getDeviceCommonList,
        getDevicesByFilter
    };
});
